import React from 'react';
import PropTypes from "prop-types";
import makeStyles from '@mui/styles/makeStyles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DownloadIcon from "@mui/icons-material/CloudDownload";
import DeleteIcon from "@mui/icons-material/Delete";


const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

const PayViaBankTransferTableComponentsForm = props => {
  const classes = useStyles();
  const { rows, columns, onDelete, onDownload, hideAction } = props;

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            {columns.map((column, i) => (
              <TableCell style={column.style} key={i}>{column.label}</TableCell>
            ))}
            {!hideAction && <TableCell style={{ width: '15%' }} align="center">Action</TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index}>
              {columns.map((column) => (
                <TableCell key={column.key} component="th" scope="row">
                  {column.key === "documentTypeLabel" ? "Bank Recipe" : row[column.key] || ''}
                </TableCell>
              ))}
              {!hideAction && <TableCell align="center">
                <IconButton onClick={() => onDelete(row.id)} size="large">
                  <DeleteIcon fontSize="small" />
                </IconButton>
                <IconButton onClick={() => onDownload(row.fileName)} size="large">
                  <DownloadIcon fontSize="small" />
                </IconButton>
              </TableCell>
              }
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {rows.length <= 0 && <Paper style={{
        display: 'flex',
        justifyContent: 'center',
        padding: 50
      }}>No Data</Paper>}
    </TableContainer >
  );
}

PayViaBankTransferTableComponentsForm.propTypes = {
  rows: PropTypes.array,
  onDownload: PropTypes.func,
  onDelete: PropTypes.func,
  columns: PropTypes.array,
  hideAction: PropTypes.bool
};

PayViaBankTransferTableComponentsForm.defaultProps = {
  rows: [],
  columns: [],
  onDownload: fn => fn,
  onDelete: fn => fn,
  hideAction: false
};

export default PayViaBankTransferTableComponentsForm;